<template>
  <div class="profil-container">
    <h3 class="profil-title">Halaman Pengisian Data Vendor</h3>
    <p class="profil-subtitle">Silahkan mengisi data sesuai kolom di bawah</p>
    <!-- 1 -->
    <input-form-penilaian-kplh
      :tables="tableInput.inputForm1"
      :listInput="listInput.inputForm1"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'kplhStore/SET_KPLH_FORM'"
      :storeName="'kplhStore'"
      :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview"
    />

    <input-form-penilaian-kplh
      :tables="tableInput.inputForm2"
      :listInput="listInput.inputForm2"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'kplhStore/SET_KPLH_FORM'"
      :storeName="'kplhStore'"
      :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview"
    />

    <input-form-penilaian-kplh
      :tables="tableInput.inputForm3"
      :listInput="listInput.inputForm3"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'kplhStore/SET_KPLH_FORM'"
      :storeName="'kplhStore'"
      :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview"
    />

    <input-form-penilaian-kplh
      :tables="tableInput.inputForm4"
      :listInput="listInput.inputForm4"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'kplhStore/SET_KPLH_FORM'"
      :storeName="'kplhStore'"
      :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview"
    />

    <input-form-penilaian-kplh
      :tables="tableInput.inputForm5"
      :listInput="listInput.inputForm5"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'kplhStore/SET_KPLH_FORM'"
      :storeName="'kplhStore'"
      :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview"
    />

    <input-form-penilaian-kplh
      :tables="tableInput.inputForm6"
      :listInput="listInput.inputForm6"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'kplhStore/SET_KPLH_FORM'"
      :storeName="'kplhStore'"
      :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview"
    />

    <input-form-penilaian-kplh
      :tables="tableInput.inputForm7"
      :listInput="listInput.inputForm7"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'kplhStore/SET_KPLH_FORM'"
      :storeName="'kplhStore'"
      :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview"
    />

    <input-form-penilaian-kplh
      :tables="tableInput.inputForm8"
      :listInput="listInput.inputForm8"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'kplhStore/SET_KPLH_FORM'"
      :storeName="'kplhStore'"
      :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview"
    />

    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goNext()" href="" class="btn-landing">
        Simpan dan Lanjutkan
      </div>
    </div>
  </div>
</template>

<script>
import InputArea from '../../components/forms/input/input-area.vue'
import BlockLabel from '../../components/forms/label/blockLabel.vue'
import PlainLabel from '../../components/forms/label/plainLabel.vue'
import UploadFile from '../../components/forms/input/multiple_upload.vue'
import InputFormPenilaianKplh from '../../components/forms/input-form-penilaian-kplh.vue'
import DescPenilaian from '../../components/desc-penilaian.vue'
export default {
  components: {
    BlockLabel,
    PlainLabel,
    InputArea,
    UploadFile,
    InputFormPenilaianKplh,
    DescPenilaian,
  },
  data() {
    return {
      tableInput: {
        inputForm1: [
          {
            name: 'A. KEBIJAKAN, KEPEMIMPINAN, & KOMITMEN',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
        inputForm2: [
          {
            name: 'B. MANAJEMEN RISIKO',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
        inputForm3: [
          {
            name: 'C. PERATURAN PERUNDANGAN DAN PERSYARATAN LAINNYA (P3L)',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
        inputForm4: [
          {
            name: 'D. TUJUAN, SASARAN, & PROGRAM KPLH',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
        inputForm5: [
          {
            name: 'E. ORGANISASI DAN SUMBER DAYA',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
        inputForm6: [
          {
            name: 'F. KOMPETENSI PEKERJA',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
        inputForm7: [
          {
            name: 'G. KOMUNIKASI',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
        inputForm8: [
          {
            name: 'H. TANGGUNG JAWAB KPLH',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
      },
      listInput: {
        inputForm1: [
          {
            type: 'form',
            name:
              'Lampirkan salinan kebijakan perusahaan tentang Keselamatan Pertambangan dan Lingkungan Hidup / Health, Safety & Environmental',
            subname: 'Sedang',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_a_1',
            inputStore: 'note_a_1',
            fileStore: 'attachment_a_1',
            tooltipText:
              'Memuat Visi, Misi, Tujuan dan Komitmen untuk menjaga keselamatan dan kesehatan kerja (pertambangan) dan kelestarian lingkungan hidup. Ditandatangani/disahkan oleh direktur atau jabatan yang lebih tinggi dan up to date (tanggal pengesahan maksimal 1 tahun kebelakang)',
            internalNoteStore: 'internal_note_a_1',
          },
          {
            type: 'form',
            name:
              'Lampirkan catatan/bukti komunikasi Kebijakan kepada pekerja, baik pekerja baru maupun pekerja lama',
            subname: 'Tinggi',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_a_2',
            inputStore: 'note_a_2',
            fileStore: 'attachment_a_2',
            tooltipText:
              'Scan asli daftar hadir sosialisasi kebijakan yang dimaksud A1',
            internalNoteStore: 'internal_note_a_2',
          },
        ],
        inputForm2: [
          {
            type: 'form',
            name:
              'Lampirkan salinan prosedur yang mengatur Prosedur Manajemen Risiko',
            subname: 'Sedang',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_b_1',
            inputStore: 'note_b_1',
            fileStore: 'attachment_b_1',
            tooltipText:
              'Memuat 5 aspek manajemen risiko (Komunikasi, Penetapan Konteks, Identifikasi Bahaya, Penetapan Pengendalian, dan Peninjauan). Disahkan oleh GM atau jabatan yang lebih tinggi',
            internalNoteStore: 'internal_note_b_1',
          },
          {
            type: 'form',
            name:
              'Lampirkan salinan hasil Identifikasi Bahaya dan Pengendalian Risiko (IBPR) yang masih berlaku',
            subname: 'Rendah',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_b_2',
            inputStore: 'note_b_2',
            fileStore: 'attachment_b_2',
            tooltipText:
              'Berdasarkan sampling:<br>- Semua aktivitas kunci (sesuai scope yang didaftarkan) teridentifikasi<br>- Semua bahaya (khususnya high risk) dari aktivitas kunci teridentifikasi<br>- Seluruh pengendalian risiko sesuai dengan bahaya yang teridentifikasi & sesuai hirarki pengendalian<br>- HIRA sesuai dengan Prosedur Manajemen Risiko',
            internalNoteStore: 'internal_note_b_2',
          },
          {
            type: 'form',
            name:
              'Lampirkan salinan contoh tindak lanjut dari hasil analisa risiko. (Contoh: Hasil analisa risiko ditindak lanjuti dengan pembuatan prosedur atau dimasukkan dalam program kerja, dll.)',
            subname: 'Sedang',
            bobot: '3',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_b_3',
            inputStore: 'note_b_3',
            fileStore: 'attachment_b_3',
            tooltipText:
              'Salinan contoh tindak lanjut dapat berupa: SOP, Kajian, Materi Presentasi, dsb. Tindak lanjut sesuai dengan persyaratan pada B.2',
            internalNoteStore: 'internal_note_b_3',
          },
          {
            type: 'form',
            name:
              'Lampirkan 2 (dua) contoh salinan Analisa Keselamatan Kerja/JSA',
            subname: 'Sedang',
            bobot: '3',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_b_4',
            inputStore: 'note_b_4',
            fileStore: 'attachment_b_4',
            tooltipText:
              '2 contoh JSA yang memuat tahapan pekerjaan lengkap (persiapan s/d selesai pekerjaan), identifikasi risiko / dampak, pengendalian risiko / dampak',
            internalNoteStore: 'internal_note_b_4',
          },
        ],
        inputForm3: [
          {
            type: 'form',
            name:
              'Lampirkan prosedur tentang peraturan perundangan dan persyaratan lainnya (P3L)?',
            subname: 'Tinggi',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_c_1',
            inputStore: 'note_c_1',
            fileStore: 'attachment_c_1',
            tooltipText:
              'Memuat ketentuan: Identifikasi P3L relevan, evaluasi kepatuhan, bagian yang melaksanakan identifikasi & evaluasi P3L dan periode / waktu pelaksanaan identifikasi & evaluasi P3L',
            internalNoteStore: 'internal_note_c_1',
          },
          {
            type: 'form',
            name:
              'Lampirkan hasil evaluasi kepatuhan perusahaan terhadap peraturan perundangan dan persyaratan lainnya ',
            subname: 'Kritis',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_c_2',
            inputStore: 'note_c_2',
            fileStore: 'attachment_c_2',
            tooltipText:
              'Seluruh P3L relevan dengan bidang yang didaftarkan telah dievaluasi dan terpenuhi 100%',
            internalNoteStore: 'internal_note_c_2',
          },
        ],
        inputForm4: [
          {
            type: 'form',
            name: 'Lampirkan program tahunan KPLH / HSE yang terakhir',
            subname: 'Tinggi',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_d_1',
            inputStore: 'note_d_1',
            fileStore: 'attachment_d_1',
            tooltipText:
              'Memuat program pengelolaan K3, pengelolaan lingkungan, dan kepatuhan terhadap peraturan perundangan tahun sebelumnya / terakhir',
            internalNoteStore: 'internal_note_d_1',
          },
          {
            type: 'form',
            name:
              'Lampikan hasil evaluasi pencapian program tahunan KPLH / HSE tahun sebelumnya',
            subname: 'Tinggi',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_d_2',
            inputStore: 'note_d_2',
            fileStore: 'attachment_d_2',
            tooltipText:
              'Evaluasi memenuhi ketentuan: Dilakukan untuk semua item program pada persyaratan D.1, terdapat tingkat pencapaian (bisa "%"), dan terdapat hasil evaluasi (khususnya untuk item program yang tidak tercapai)',
            internalNoteStore: 'internal_note_d_2',
          },
        ],
        inputForm5: [
          {
            type: 'form',
            name:
              'Lampirkan struktur organisasi yang memiliki tanggung jawab KPLH',
            subname: 'Rendah',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_e_1',
            inputStore: 'note_e_1',
            fileStore: 'attachment_e_1',
            tooltipText:
              'SO memenuhi ketentuan:  terdapat bagian yang bertanggung jawab terhadap K3 & KO serta Lingkungan, terdapat penjelasan tugas & tanggung jawab tanggung jawab bagian K3 & KO serta bagian Lingkungan tersebut',
            internalNoteStore: 'internal_note_e_1',
          },
          {
            type: 'form',
            name:
              'Lampirkan daftar Tenaga Teknis Pertambangan / Tenaga Teknik Khusus yang bertanggung jawab terhadap Keselamatan Operasi atau Keselamatan Sarana, Prasarana, Instalasi & Peralatan (contoh: Paramedis, commissioner, ahli higiene, juru penyelamat tambang, Auditor Internal SMKP, AK3, dll.)',
            subname: 'Tinggi',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_e_2',
            inputStore: 'note_e_2',
            fileStore: 'attachment_e_2',
            tooltipText:
              '- Daftar memuat: Nama, peran Tenaga Teknis Pertambangan / Tenaga Teknik Khusus, dan sertifikasi/kompetensi<br>- Daftar mencakup semua Tenaga Teknis Pertambangan / Tenaga Teknik Khusus kebutuhan operasional bidang yang diajukan',
            internalNoteStore: 'internal_note_e_2',
          },
          {
            type: 'form',
            name: 'Lampirkan salinan bukti kompetensi dari personil tersebut',
            subname: 'Tinggi',
            bobot: '4',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_e_3',
            inputStore: 'note_e_3',
            fileStore: 'attachment_e_3',
            tooltipText:
              'Melampirkan >70% salinan bukti kompetensi yang sesuai dan masih berlaku dengan mengacu pada persyaratan pada persyaratan E.2',
            internalNoteStore: 'internal_note_e_3',
          },
        ],
        inputForm6: [
          {
            type: 'form',
            name:
              'Lampirkan salinan matriks / peta / kamus kompetensi perusahaan',
            subname: 'Tinggi',
            bobot: '4',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_f_1',
            inputStore: 'note_f_1',
            fileStore: 'attachment_f_1',
            tooltipText:
              '- Matriks sudah dipetakan untuk semua departemen dan level jabatan<br>- Matriks memuat nama jabatan, nama kompetensi, dan nama pelatihan',
            internalNoteStore: 'internal_note_f_1',
          },
          {
            type: 'form',
            name:
              'Lampirkan salinan hasil identifikasi kompetensi pekerja terhadap matriks / peta / kamus kompetensi yang terakhir',
            subname: 'Tinggi',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_f_2',
            inputStore: 'note_f_2',
            fileStore: 'attachment_f_2',
            tooltipText:
              '- Semua jenis kompetensi & pelatihan mengacu  matriks pada persyaratan F1<br>- Semua nama-nama personil mengacu SO pada persyaratan E1',
            internalNoteStore: 'internal_note_f_2',
          },
          {
            type: 'form',
            name: 'Lampirkan rencana pelatihan terkait KPLH tahun terakhir',
            subname: 'Tinggi',
            bobot: '3',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_f_3',
            inputStore: 'note_f_3',
            fileStore: 'attachment_f_3',
            tooltipText:
              '- Jenis pelatihan mengacu TNA pada persyaratan  F2 dan regulasi relevan (mandatory training based on regulation)<br>- Terdapat informasi waktu dan penyelenggara (internal/eksternal)',
            internalNoteStore: 'internal_note_f_3',
          },
          {
            type: 'form',
            name:
              'Lampirkan hasil evaluasi pelaksanaan pelatihan dan evaluasi efektifitas hasil pelatihan',
            subname: 'Kritis',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_f_4',
            inputStore: 'note_f_4',
            fileStore: 'attachment_f_4',
            tooltipText:
              '- Evaluasi pelaksanaan: tingkat pencapaian plan vs aktual serta tindak lanjut atas pencapaian yang masih kurang; dan<br>- Evaluasi efektivitas: tingkat kelulusan atau reaction (tingkat pemahaman dari pre & post test) serta tindak lanjut terhadap permasalahan yang ditemukan',
            internalNoteStore: 'internal_note_f_4',
          },
        ],
        inputForm7: [
          {
            type: 'form',
            name:
              'Lampirkan salinan rencana program pertemuan KPLH tahun terakhir',
            subname: 'Tinggi',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_g_1',
            inputStore: 'note_g_1',
            fileStore: 'attachment_g_1',
            tooltipText:
              'Terdapat rencana program pertemuan rutin (harian, mingguan dan bulanan)',
            internalNoteStore: 'internal_note_g_1',
          },
          {
            type: 'form',
            name:
              'Lampirkan salinan rapat KPLH (mis. Safety Talk) yang dilakukan di perusahaan (minimal 3)',
            subname: 'Sedang',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_g_2',
            inputStore: 'note_g_2',
            fileStore: 'attachment_g_2',
            tooltipText: 'minimal 3 daftar hadir & notulensi pertemuan rutin',
            internalNoteStore: 'internal_note_g_2',
          },
          {
            type: 'form',
            name:
              'Lampirkan salinan kehadiran induksi KPLH kepada karyawan (minimal 2)',
            subname: 'Sedang',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_g_3',
            inputStore: 'note_g_3',
            fileStore: 'attachment_g_3',
            tooltipText: 'minimal 2 daftar hadir induksi',
            internalNoteStore: 'internal_note_g_3',
          },
        ],
        inputForm8: [
          {
            type: 'form',
            name:
              'Lampirkan 3 contoh salinan deskripsi pekerjaan / job desc karyawan',
            subname: 'Sedang',
            bobot: '4',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_h_1',
            inputStore: 'note_h_1',
            fileStore: 'attachment_h_1',
            tooltipText:
              '1 job desc personil HSE dan 2 job desc personil operation dengan variasi level jabatan',
            internalNoteStore: 'internal_note_h_1',
          },
        ],
      },
    }
  },
  computed: {
    is_hse_validation() {
      return this.$store.state.kplhStore.is_hse_validation
    },
    is_head_validation() {
      return this.$store.state.kplhStore.is_head_validation
    },
    is_preview() {
      return this.$store.state.kplhStore.is_preview
    },
  },
  methods: {
    goBack() {
      this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'profile' })
    },
    goNext() {
      if (this.is_preview) {
        this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'grupi1' })
      } else {
        this.$store.commit('kplhStore/SUBMIT_PENILAIAN_FOR_DRAFT', {
          onSuccess: () => {
            this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'grupi1' })
          },
        })
      }
    },
  },
}
</script>
<style scoped>
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-body {
  display: flex;
  flex-direction: column;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
